import { z } from "zod";
import { createModel, type InferModelType } from "@/common/helpers/models";

export type ButtonCmsProps = InferModelType<typeof ButtonCmsProps>;

export const ButtonCmsProps = createModel(
  z.object({
    variant: z.enum(["primary", "secondary", "tertiary", "destructive", "ghost", "link", "transparent"]),
    size: z.enum(["default", "sm", "lg"]),
  }),
);
